import { watch } from "vue"

/**
 * Creates a watcher to check the user details and fill in the form as required
 * 
 * @param {Object} data 
 * @param {Object} form 
 * @returns {Function} cancels the watch if executed
 */
export function createUserDetailsWatch(data, form){
    /**
     * When the user is retrieved from the Api we should set the user on the form
     */
    return watch(
        data.user.details,
        (userDetails) => {
            form.fields.value.user.email              = userDetails.email 
            form.fields.value.user.email_confirmation = userDetails.email
            form.fields.value.user.name               = userDetails.name 
        }
    )
}